var map = {
	"./brasilstartups/horizontal-logo.svg": 6899,
	"./caboverde/horizontal-logo.svg": 741,
	"./canaleducacao/horizontal-logo.svg": 4222,
	"./demo/horizontal-logo.svg": 467,
	"./egepi/horizontal-logo.svg": 6904,
	"./encceja/horizontal-logo.svg": 4039,
	"./fic/horizontal-logo.svg": 9766,
	"./iesb/horizontal-logo.svg": 7163,
	"./inkluziva/horizontal-logo.svg": 3833,
	"./maiseducacao/horizontal-logo.svg": 4191,
	"./oab/horizontal-logo.svg": 5954,
	"./pit/horizontal-logo.svg": 4983,
	"./powerforgirls/horizontal-logo.svg": 2845,
	"./quartosecretariado/horizontal-logo.svg": 2474,
	"./retina/horizontal-logo.svg": 7979,
	"./seducpi/horizontal-logo.svg": 4885,
	"./siape/horizontal-logo.svg": 2052,
	"./tjpara/horizontal-logo.svg": 9058,
	"./unisescoop/horizontal-logo.svg": 5796,
	"./vegalabs/horizontal-logo.svg": 4977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1482;